import React from 'react';

import capitalize from 'lodash/capitalize';

import { Box, Chip, Typography } from '@mui/material';

import { IMAGE_CLASSIFICATION_COLOR, IMAGE_CLASSIFICATION_LABEL, buildImageUrl } from '../constants';
import { ImageScore } from '../types';

interface Props {
  image: ImageScore;
  isHero?: boolean;
  large?: boolean;
  medium?: boolean;
  fluid?: boolean;
  onClick: (image: ImageScore) => void;
}

export default function CurationImageCard({
  image,
  isHero = false,
  large = false,
  medium = false,
  fluid = false,
  onClick,
}: Props) {
  const width = fluid ? undefined : large ? 280 : medium ? 190 : 160;
  const height = large ? 200 : medium ? 135 : 120;

  return (
    <Box
      onClick={() => onClick(image)}
      sx={{
        position: 'relative',
        cursor: 'pointer',
        borderRadius: 1,
        overflow: 'hidden',
        width: fluid ? '100%' : width,
        flexShrink: 0,
        '&:hover': { opacity: 0.85 },
      }}
    >
      <Box
        component="img"
        src={buildImageUrl(image.imageServiceId, fluid ? 600 : (width as number) * 2)}
        alt={(image.categories ?? []).join(', ')}
        sx={{ width: '100%', height: fluid ? 160 : height, objectFit: 'cover', display: 'block' }}
      />
      {isHero && (
        <Chip
          label="HERO"
          size="small"
          sx={{
            position: 'absolute',
            top: 6,
            left: 32,
            fontWeight: 'bold',
            fontSize: '0.7rem',
            bgcolor: 'secondary.main',
            color: 'common.white',
          }}
        />
      )}
      <Chip
        label={IMAGE_CLASSIFICATION_LABEL[image.classification]}
        size="small"
        color={IMAGE_CLASSIFICATION_COLOR[image.classification]}
        sx={{
          position: 'absolute',
          top: 6,
          right: 6,
          fontWeight: 'bold',
          fontSize: '0.65rem',
        }}
      />
      <Box sx={{ position: 'absolute', bottom: 0, left: 0, right: 0, bgcolor: 'rgba(0,0,0,0.6)', px: 1, py: 0.5 }}>
        <Typography variant="caption" color="white" noWrap>
          {(image.categories ?? []).map(capitalize).join(', ')}
        </Typography>
      </Box>
    </Box>
  );
}
